/**
 * PURPOSE: Servicios para el modelo matches (GET/POST/PUT/PATCH).
 * RESPONSIBILITIES:
 *  - Sí: consumir endpoints de matches (listar, crear, editar).
 *  - No: no maneja UI ni estado; solo requests.
 * COLLABORATORS:
 *  - Componentes que editan programación/resultados de matches.
 * NOTES:
 *  - Errores se propagan para que UI decida cómo mostrarlos.
 * ROUTE: src/services/match.js
 */
import httpService from "./httpService.js";

// EDITAR RESULTADO / ESTADO BASE DEL MATCH
export async function updateMatchData(payload) {
  return httpService.patch(`/patchmatchdata`, payload).then((r) => r.data);
}

// EDITAR OPCIONES AVANZADAS DESDE MODAL PROGRAMACIÓN
export async function updateMatchAdvancedSettings(payload) {
  return httpService.patch(`/patchmatchadvancedsettings`, payload).then((r) => r.data);
}

// CAMBIO DE PARTICIPANTE 1/2 DESDE OPCIONES AVANZADAS (FTR-0039)
// Endpoint V2 protegido: el backend exige rol 1 o 4 con acceso al evento del partido, estado 1 (por jugarse),
// sin actividad deportiva, y candidatos de la fase de grupos del evento/deporte (del mismo grupo si el partido
// lo tiene). Devuelven el sobre V2 desenvuelto y propagan los errores HTTP al llamador.
const MATCH_PARTICIPANTS_BASE = "/api/hayllis/v2/match-participants/matches";

// Contexto: { editable, blockReason, message, sameGroupOnly, sides, candidates }.
export async function getMatchParticipantsContext(idmatch) {
  return httpService
    .get(`${MATCH_PARTICIPANTS_BASE}/${encodeURIComponent(idmatch)}`)
    .then((r) => r?.data?.data ?? null);
}

// Solo se envían los lados que cambian ({ idparticipant1 } y/o { idparticipant2 }).
export async function replaceMatchParticipants(idmatch, changes) {
  return httpService
    .put(`${MATCH_PARTICIPANTS_BASE}/${encodeURIComponent(idmatch)}`, changes)
    .then((r) => r?.data?.data ?? null);
}
